/**
 * Functions for interacting with OpenAI API via Supabase Edge Functions
 */

/**
 * Makes a call to the OpenAI API through Supabase Edge Function
 * @param prompt - The prompt to send to OpenAI
 * @returns The response from OpenAI
 */
export const callOpenAI = async (prompt: string): Promise<any> => {
  try {
    const response = await fetch(
      "https://yxkzzwjghxjkluwnjjxa.supabase.co/functions/v1/openai",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ prompt }),
      }
    );

    if (!response.ok) {
      console.error("Error calling OpenAI API:", await response.text());
      return null;
    }

    // Parse the response and try different possible formats
    const data = await response.json();

    // Try different possible properties where the result might be
    let result = "";
    if (data?.result) {
      result = data.result;
    } else if (data?.content) {
      result = data.content;
    } else if (typeof data === "string") {
      result = data;
    }

    return result.trim();
  } catch (error) {
    console.error("Error calling OpenAI API:", error);
    return null;
  }
};
